
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/property/[propertyId]",
      function () {
        return require("private-next-pages/property/[propertyId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/property/[propertyId]"])
      });
    }
  